
export enum SwotEnum {
    STRENGTH = "STRENGTH",
    WEAKNESS = "WEAKNESS",
    OPPORTUNITY = "OPPORTUNITY",
    THREAT = "THREAT"
}